// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3SkX4","loaderOuter":"PageOverlayLoader_loaderOuter__SjKtU"};